import React from 'react';
import { IconTypeProps } from '../icon';

export function IconCheckCircular({
  onClick = () => {},
  className = '',
  ...rest
}: IconTypeProps) {
  return (
    <svg
      className={className}
      viewBox='0 0 60 60'
      onClick={onClick}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M30 55.375C23.2701 55.375 16.8159 52.7016 12.0572 47.9428C7.29843 43.1841 4.625 36.7299 4.625 30C4.625 23.2701 7.29843 16.8159 12.0572 12.0572C16.8159 7.29843 23.2701 4.625 30 4.625C36.7299 4.625 43.1841 7.29843 47.9428 12.0572C52.7016 16.8159 55.375 23.2701 55.375 30C55.375 36.7299 52.7016 43.1841 47.9428 47.9428C43.1841 52.7016 36.7299 55.375 30 55.375ZM30 59C37.6913 59 45.0675 55.9447 50.5061 50.5061C55.9447 45.0675 59 37.6913 59 30C59 22.3087 55.9447 14.9325 50.5061 9.4939C45.0675 4.05535 37.6913 1 30 1C22.3087 1 14.9325 4.05535 9.4939 9.4939C4.05535 14.9325 1 22.3087 1 30C1 37.6913 4.05535 45.0675 9.4939 50.5061C14.9325 55.9447 22.3087 59 30 59V59Z"
        strokeWidth="2"
      />
      <path d="M40.3047 18.7838L40.3019 18.7873L28.0605 34.3843L20.8721 27.1924L20.8658 27.1862L20.8593 27.1801C20.2492 26.6115 19.4421 26.302 18.6083 26.3167C17.7744 26.3314 16.9788 26.6693 16.389 27.259C15.7993 27.8487 15.4615 28.6443 15.4468 29.4782C15.4321 30.3121 15.7416 31.1191 16.3102 31.7293L16.3161 31.7357L16.3224 31.7419L25.9141 41.3373L25.9145 41.3377C26.2204 41.643 26.5847 41.8836 26.9856 42.0452C27.3865 42.2067 27.8159 42.2858 28.2481 42.2778C28.6802 42.2698 29.1064 42.1748 29.501 41.9985C29.8957 41.8223 30.2508 41.5683 30.5452 41.2518L30.5579 41.2382L30.5695 41.2236L45.0276 23.1511C45.6011 22.5406 45.9143 21.7303 45.9 20.8923C45.8856 20.0467 45.539 19.2408 44.9351 18.6487C44.3312 18.0567 43.5185 17.7261 42.6728 17.7284C41.8281 17.7307 41.0183 18.065 40.4179 18.6591C40.3776 18.6983 40.3398 18.7399 40.3047 18.7838Z" />
    </svg>
  );
}
